import React, { useState, useEffect } from "react";
import "./ECommerceComponents.css";
import axios from "axios";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import BottomToust from "../../Components/BottomToust/BottomToust";
import { Url, security_key } from "../../Services/Api";

const CreditCardGateways = () => {
  const [gateways, setGateways] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showMessage, setShowMessage] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [error, setError] = useState(null);


  async function fetchCreditCardGateways() {
    setLoading(true);
    setError(null);

    setTimeout(async () => {
      try {

        const token = sessionStorage.getItem('authToken');
        const headers = {
          Authorization: `Bearer ${token}`,
          'x-api-key': security_key
        };
        const response = await axios.get(
          `${Url}/api/v1/credit-card-gateway/all`
        );

        const gatewaysData = response.data.data || [];

        setGateways(gatewaysData);

        setToastMessage(
          "Credit Card Gateways have been fetched successfully!"
        );
        setShowMessage(true);
      } catch (error) {
        const errMsg =
          error?.response?.data?.message || error.message;

        setError(errMsg);

        setToastMessage(
          `Failed to fetch Credit Card Gateways: ${errMsg}`
        );

        setShowMessage(true);
      } finally {
        setLoading(false);
      }
    }, 500);
  }

  useEffect(() => {
    fetchCreditCardGateways();
  }, []);

  const handleCloseMessageModal = () => {
    setShowMessage(false);
  };

  useEffect(() => {
    if (showMessage === true) {
      const timeOut = setTimeout(() => {
        setShowMessage(false);
      }, 3000);

      return () => clearTimeout(timeOut);
    }
  }, [showMessage]);


  const handleToggle = async (gateway) => {
    try {
      // CHECK: If this gateway is already active
      // and it is the ONLY active gateway,
      // then prevent turning it OFF
      const activeGateways = gateways.filter(
        (g) => g.activeStatus === 1
      );

      if (
        gateway.activeStatus === 1 &&
        activeGateways.length === 1
      ) {
        setToastMessage(
          "At least one payment gateway must remain active"
        );

        setShowMessage(true);
        return;
      }

      setLoading(true);

      const token = sessionStorage.getItem('authToken');
      const headers = {
        Authorization: `Bearer ${token}`,
        'x-api-key': security_key,
        "Content-Type": "application/json",
      };
      const response = await fetch(
        `${Url}/api/v1/credit-card-gateway/activate/${gateway._id}`,
        {
          method: "PUT",
          headers: headers,
        }
      );

      if (!response.ok) {
        throw new Error(
          "Failed to update credit card gateway status"
        );
      }

      setToastMessage(
        `${gateway.name} status updated successfully`
      );

      setShowMessage(true);

      // REFRESH UPDATED DATA
      await fetchCreditCardGateways();

    } catch (error) {
      console.error(
        "Error updating credit card gateway:",
        error
      );

      setToastMessage(
        `Failed to update ${gateway.name}`
      );

      setShowMessage(true);
    } finally {
      setLoading(false);
    }
  };
  const getGatewayImage = (imagePath) => {
    return imagePath ? `${Url + imagePath}` : "";
  };

  return (
    <>
      <div className="PaymentMethodsMainPage">
        <div className="PaySection-01">
          <div className="Row-01">
            <div className="Leftside">
              <div className="MainPayContainer">
                <span className="PayMethods-Header">
                  Credit/Debit Card Gateways
                </span>
              </div>

              <div className="BodyContainer-PayMethod">
                {loading ? (
                  Array(2)
                    .fill()
                    .map((_, index) => (
                      <div
                        key={index}
                        className="PaymentMethodShimmerRow"
                      >
                        <div style={{ marginLeft: "10px" }}>
                          <ShimmerLoader
                            width="60px"
                            height="50px"
                            borderRadius="20%"
                          />
                        </div>

                        <div style={{ marginLeft: "30px" }}>
                          <ShimmerLoader
                            width="230px"
                            height="20px"
                            borderRadius="5px"
                          />
                        </div>

                        <div style={{ marginLeft: "70px" }}>
                          <ShimmerLoader
                            width="60px"
                            height="30px"
                          />
                        </div>
                      </div>
                    ))
                ) : gateways.length === 0 ? (
                  <div className="NoPaymentMethodsMessage">
                    No Credit Card Gateways Found
                  </div>
                ) : (
                  gateways
                    .slice()
                    .sort(
                      (a, b) =>
                        a.menu_order - b.menu_order
                    )
                    .map((gateway) => (
                      <div
                        key={gateway._id}
                        className="PaymentMethodRow"
                      >
                        {gateway.logo ? (
                          <img
                            src={getGatewayImage(
                              gateway.logo
                            )}
                            alt={gateway.name}
                            className="PaymentMethodImage"
                          />
                        ) : (
                          <div
                            className="PaymentMethodImage"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: "#f5f5f5",
                              fontSize: "12px",
                              fontWeight: "600",
                            }}
                          >
                            {gateway.name?.charAt(0)}
                          </div>
                        )}

                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <span className="PaymentMethodName">
                            {gateway.name}
                          </span>

                          <span
                            style={{
                              fontSize: "12px",
                              color: "#777",
                            }}
                          >
                            {gateway.description}
                          </span>
                        </div>

                        <div
                          className={`CustomToggle ${gateway.activeStatus === 1
                            ? "Enabled"
                            : "Disabled"
                            }`}
                          onClick={() => handleToggle(gateway)}
                          style={{
                            cursor:
                              gateway.activeStatus === 1
                                ? "not-allowed"
                                : "pointer",
                          }}
                        >
                          <div className="ToggleCircle"></div>
                        </div>
                      </div>
                    ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <BottomToust
        showMessage={showMessage}
        message={toastMessage}
        handleCloseMessageModal={
          handleCloseMessageModal
        }
      />
    </>
  );
};

export default CreditCardGateways;